<template>
  <v-card elevation="0" class="all-trade-tab rounded-0 mt-5" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs v-model="tab" :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="ml-0"> Investors </v-tab>
      <v-tab>
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Live Orders
      </v-tab>
      <v-tab> Reports </v-tab>
      <v-tab> Commission </v-tab>
      <v-tab> Commission History</v-tab>
      <v-tab-item>
        <InvestorAccountTab></InvestorAccountTab>
      </v-tab-item>
      <v-tab-item>
        <LiveOrderTab></LiveOrderTab>
      </v-tab-item>
      <v-tab-item>
        <ReportsTab></ReportsTab>
      </v-tab-item>
      <v-tab-item>
        <CommissionTab></CommissionTab>
      </v-tab-item>
      <v-tab-item>
        <CommissionHistoryTab></CommissionHistoryTab>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import CommissionHistoryTab from './CommissionHistoryTab.vue';
import CommissionTab from './CommissionTab.vue';
import InvestorAccountTab from './InvestorAccountTab.vue';
import LiveOrderTab from './LiveOrderTab.vue';
import ReportsTab from './ReportsTab.vue';

import { mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
  components: {
    InvestorAccountTab,
    LiveOrderTab,
    ReportsTab,
    CommissionTab,
    CommissionHistoryTab,
  },
  data() {
    return {
      tab: 0,
    };
  },

  watch: {
    tab(newVal) {
      const account = this.$route.query.account;
      switch (newVal) {
        case 1:
          this.getLiveOrders(account);
          break;
        case 2:
          this.getReports(account);
          break;
      }
    },
  },

  methods: {
    ...mapActions("mam", {
      getLiveOrders: MAM__ACTIONS.GETLIVEORDERS,
      getReports: MAM__ACTIONS.GETREPORTS,
    }),
  },
};
</script>